// extracted by mini-css-extract-plugin
export default {"wrapper":"TeamGroupManage_wrapper__Bzfu8","col":"TeamGroupManage_col__VtH6c"};